import { api } from '@goaltree/backend/convex/_generated/api'
import { useConvexAuth, useQuery } from 'convex/react'

// The weekly-review prompt goes out Sunday; keep the nudge up through Monday
// (the user's local days) until that week's review is saved.
export function useReviewDue() {
  const { isAuthenticated } = useConvexAuth()
  const status = useQuery(api.weeklyReview.getReviewStatus, isAuthenticated ? {} : 'skip')
  if (!status) return false
  return (status.localDay === 0 || status.localDay === 1) && !status.alreadyReviewed
}
